export const email = (id, value) => {
  return [
    id,
    {
      initialValue: value,
      rules: [
        {
          required: true,
          email: true,
          message: "Por favor informe um e-mail"
        }
      ]
    }
  ];
};

export const obrigatorio = (id, value) => {
  return [
    id,
    {
      initialValue: value,
      rules: [
        {
          required: true,
          message: "Obrigatório"
        }
      ]
    }
  ];
};
